import React from "react";

const SegmentedProgressBar = ({ data = [] }) => {
  const sortedData = [...data].sort((a, b) => b.percentage - a.percentage);

  return (
    <div className="w-full">
      <div className="flex overflow-hidden gap-0.5">
        {sortedData.map((item, index) => (
          <div
            key={index}
            style={{
              width: `${item.percentage}%`,
              minWidth: "72px"
            }}
            className="space-y-1"
          >
              <span className="text-xs font-medium">
                {item.percentage}%
              </span>
            <div
              className="h-1 w-full rounded-full"
              style={{ backgroundColor: item.color }}
            />
            <div className="flex flex-row items-center gap-1">
              <div
              className="h-2 w-2 rounded-full"
              style={{ backgroundColor: item.color }}
            ></div>
            <span className="font-medium text-xs">{item.source}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SegmentedProgressBar;
